/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
// component
import PasswordUpdated from 'pages/auth/passwordupdated/passwordupdated';



/* ========== ~~~~~~~~~~ AUTH PASSWORD UPDATED : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    email: authStatus.tokenData.email
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordUpdated);
